export const translations = {
  kz: {
    // PhoneAuth
    phoneTitle: 'Кепілгер нысаны',
    enterPhone: 'Телефон нөірін енгізіңіз',
    phoneLabel: 'Телефон нөмірі',
    phoneHelper: 'Телефон нөмірінді енгізіңіз',
    getCode: 'Код алу',
    sending: 'Жіберілуде...',
    enterSms: 'SMS кодын енгізіңіз',
    codeSentTo: 'Код WhatsApp-қа жіберілді',
    smsCode: 'SMS код',
    confirm: 'Растау',
    checking: 'Тексерілуде...',
    changePhone: 'Телефон нөмірін өзгерту',
    enterPhoneDescription: 'Микрокредит бойынша кепілгер болу ұсынысы бар сілтемені алған телефон нөміріңізді енгізіңіз',
    
    // GuarantorForm
    guarantorForm: 'Кепілгер нысаны',
    fullName: 'Аты-жөні',
    iin: 'ЖСН',
    idNumber: 'Жеке куәлік нөмірі',
    birthDate: 'Туған күні',
    idIssueDate: 'Берілген күні',
    idExpiryDate: 'Жарамды мерзімі',
    registrationAddress: 'Тіркеу мекенжайы',
    address: 'Тұрғылықты мекенжайы',
    phone: 'Телефон нөмірі',
    uploadPassport: 'Жеке куәлікті жүктеу',
    changePassport: 'Жеке куәлікті өзгерту',
    agreementText: 'Дербес деректерді өңдеуге келісемін',
    back: 'Артқа',
    submit: 'Жіберу',
    fullNameRequired: 'Аты-жөніңізді енгізіңіз',
    iinInvalid: 'Дұрыс ЖСН енгізіңіз (12 сан)',
    idNumberRequired: 'Жеке куәлік нөмірін енгізіңіз',
    birthDateRequired: 'Туған күнін таңдаңыз',
    idIssueDateRequired: 'Берілген күнін таңдаңыз',
    idExpiryDateRequired: 'Жарамдылық мерзімін таңдаңыз',
    registrationAddressRequired: 'Тіркеу мекенжайын енгізіңіз',
    addressRequired: 'Тұрғылықты мекенжайын енгізіңіз',
    phoneInvalid: 'Дұрыс телефон нөмірін енгізіңіз',
    passportRequired: 'Жеке куәлікті жүктеңіз',
    unsupportedFileType: 'Қолдау көрсетілмейтін файл форматы',
    fileUploadSuccess: 'Файл сәтті жүктелді',
    fileUploadError: 'Файлды жүктеу кезінде қате',
    formValidationError: 'Барлық міндетті өрістерді толтырыңыз',
    submitSuccess: 'Деректер сәтті жіберілді',
    submitError: 'Деректерді жіберу кезінде қате',
    previewDocument: 'Құжатты қарау',
    pdfOnlyMessage: 'Тек PDF форматында',
    howToGetPdfTitle: 'PDF форматында құжатты қалай алуға болады:',
    kaspiInstructions: 'Kaspi.kz мобильді қосымшасында «Мемлекеттік қызметтер» → Цифрлық құжаттар қызметін ашыңыз, тізімнен қажетті құжатты таңдап, «Құжатты жіберу» түймесін басыңыз.',
    // OCR messages
    processingDocument: 'Құжат өңделуде...',
    ocrSuccess: 'Құжат табысты танылды! Деректер толтырылды',
    ocrError: 'Құжатты тану кезінде қателік пайда болды. Формаларды қолмен толтырыңыз.',
    autoRecognitionHint: 'Құжаттан деректер автоматты түрде танылады',
    numberCopied: 'Нөмір көшірілді',

    // Errors
    phoneNotFound: 'Телефон нөмірі жүйеде табылмады. Нөмірдің дұрыстығын тексеріңіз немесе менеджерге хабарласыңыз.',
    wrongCode: 'Қате код енгізілді. Қайталап көріңіз.',
    generalError: 'Қате орын алды. Әрекетті қайталаңыз.',
    networkError: 'Желі қатесі орын алды. Қайталап көріңіз.',
    serverError: 'Сервер қатесі орын алды. Кейінірек қайталап көріңіз.',
    noGuarantorId: 'Кепілгер идентификаторы табылмады. Сілтемені тексеріңіз.',
    agreementRequired: 'Дербес деректерді өңдеуге келісім беру қажет.',

    // Info text
    infoText: 'Сізді {name} микрокредит шарты бойынша кепілгер болуға шақырады №{creditRequestNumber} келесі шарттармен:',
    loanAmountLabel: 'Микрокредит сомасы:',
    loanTermLabel: 'Микрокредит мерзімі:',
    formNote: 'Өтініш бойынша оң шешім қабылданған жағдайда, тиісті құжаттарға қол қою үшін компания кеңсесіне келу қажет болатынын назарыңызға саламыз. Біздің менеджер сізбен алдын ала байланысып, келу уақытын келіседі.'
  },
  ru: {
    // PhoneAuth
    phoneTitle: 'Форма гаранта',
    enterPhone: 'Введите номер телефона',
    phoneLabel: 'Номер телефона',
    phoneHelper: 'Введите свой номер телефона',
    getCode: 'Получить код',
    sending: 'Отправка...',
    enterSms: 'Введите код из СМС',
    codeSentTo: 'Код отправлен на WhatsApp',
    smsCode: 'Код из СМС',
    confirm: 'Подтвердить',
    checking: 'Проверка...',
    changePhone: 'Изменить номер телефона',
    enterPhoneDescription: 'Введите номер телефона, на который вы получили ссылку с предложением выступить гарантом по микрокредиту',

    // GuarantorForm
    guarantorForm: 'Форма поручителя',
    fullName: 'ФИО',
    iin: 'ИИН',
    idNumber: 'Номер удостоверения',
    birthDate: 'Дата рождения',
    idIssueDate: 'Дата выдачи',
    idExpiryDate: 'Действителен до',
    registrationAddress: 'Адрес прописки',
    address: 'Адрес проживания',
    phone: 'Номер телефона',
    uploadPassport: 'Загрузить удостоверение личности',
    changePassport: 'Изменить удостоверение личности',
    agreementText: 'Я согласен на обработку персональных данных',
    back: 'Назад',
    submit: 'Отправить',
    fullNameRequired: 'Введите ФИО',
    iinInvalid: 'Введите корректный ИИН (12 цифр)',
    idNumberRequired: 'Введите номер удостоверения',
    birthDateRequired: 'Выберите дату рождения',
    idIssueDateRequired: 'Выберите дату выдачи',
    idExpiryDateRequired: 'Выберите срок действия',
    registrationAddressRequired: 'Введите адрес прописки',
    addressRequired: 'Введите адрес проживания',
    phoneInvalid: 'Введите корректный номер телефона',
    passportRequired: 'Загрузите удостоверение личности',
    unsupportedFileType: 'Неподдерживаемый формат файла',
    fileUploadSuccess: 'Файл успешно загружен',
    fileUploadError: 'Ошибка при загрузке файла',
    formValidationError: 'Заполните все обязательные поля',
    submitSuccess: 'Данные успешно отправлены',
    submitError: 'Ошибка при отправке данных',
    previewDocument: 'Просмотреть документ',
    pdfOnlyMessage: 'Только в формате PDF',
    howToGetPdfTitle: 'Как получить документ в формате PDF:',
    kaspiInstructions: 'В мобильном приложении Kaspi.kz откройте сервис «Госуслуги» → Цифровые документы, выберите нужный из списка и нажмите «Отправить документ».',
    // OCR messages
    processingDocument: 'Обработка документа...',
    ocrSuccess: 'Документ успешно распознан! Данные заполнены',
    ocrError: 'Произошла ошибка при распознавании документа. Заполните формы вручную.',
    autoRecognitionHint: 'Данные из удостоверения будут распознаны автоматически',
    numberCopied: 'Номер скопирован',

    // Errors
    phoneNotFound: 'Номер телефона не найден в системе. Пожалуйста, проверьте правильность номера или обратитесь к менеджеру.',
    wrongCode: 'Введен неверный код. Попробуйте еще раз.',
    generalError: 'Произошла ошибка. Пожалуйста, попробуйте позже.',
    networkError: 'Ошибка сети. Пожалуйста, попробуйте еще раз.',
    serverError: 'Ошибка сервера. Пожалуйста, попробуйте позже.',
    noGuarantorId: 'Идентификатор гаранта не найден. Пожалуйста, проверьте ссылку.',
    agreementRequired: 'Необходимо согласие на обработку персональных данных.',

    // Info text
    infoText: 'Информируем Вас о том, что {name} предлагает Вам выступить гарантом по договору микрокредита №{creditRequestNumber} на следующих условиях:',
    loanAmountLabel: 'Сумма микрокредита:',
    loanTermLabel: 'Срок микрокредита:',
    formNote: 'Обращаем Ваше внимание, что при положительном решении по заявке необходимо будет посетить офис компании для подписания соответствующей документации. Наш менеджер предварительно свяжется с Вами для согласования удобного времени визита.'
  }
}; 